import { useContext } from 'react';
import { ProjectsContext } from '../contexts/ProjectsContext';
import logger from '../utils/logger';

/**
 * Hook to get projects data from context
 * @returns {Object} Projects dictionary
 */
export const useProjects = () => {
  const projects = useContext(ProjectsContext);

  if (!projects) {
    logger.warn('useProjects called outside of ProjectsProvider');
    return {};
  }

  return projects;
};

/**
 * Legacy function for backward compatibility
 * This will be used by components that haven't been updated yet
 * @deprecated Use useProjects hook instead
 */
export const buildProjectsDict = () => {
  logger.warn('buildProjectsDict is deprecated. Use useProjects hook instead.');

  // Return empty object for now - components should use the hook
  return {};
};
